import './index.scss';

/*
* Uncomment the code below to enable front end JS for your block
*/

/*

import gsap from 'gsap';

document.addEventListener('DOMContentLoaded', function(){
  
  function handleCustomBlock(block){
    // Main block logic goes here...
    // const example = block.querySelectorAll('.example')
  }

  const blockInstances = document.querySelectorAll('.pd-block-instructor')

  if(!!blockInstances && blockInstances.length > 0){
    blockInstances.forEach(block => {
      handleCustomBlock(block)
    })
  }

})

*/